import React, { useState, useEffect } from 'react';
import API_CONFIG from '../config/apiConfig';

const DataToggle = () => {
  const [useMock, setUseMock] = useState(API_CONFIG.useMockData);

  useEffect(() => {
    setUseMock(API_CONFIG.useMockData);
  }, []);

  // 如果使用真实后端API，则不显示按钮
  if (!useMock) {
    return null;
  }

  const toggleDataMode = () => {
    const newMode = !useMock;
    API_CONFIG.toggleMockData(newMode);
  };

  const buttonStyle = {
    position: 'fixed',
    top: '10px',
    right: '10px',
    padding: '10px 15px',
    backgroundColor: '#ff4d4f',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    zIndex: 1000,
    fontSize: '14px',
    fontWeight: 'bold'
  };

  return (
    <button 
      style={buttonStyle}
      onClick={toggleDataMode}
      title="Toggle between mock data and real backend"
    >
      Using Mock Data
    </button>
  );
};

export default DataToggle;